import css from 'styled-jsx/css';
import IRanking from '@/models/viewModels/IRanking';
import moduleStyles from './top-ranked-subjects.module.scss';

type Props = {
  topRankedSubjects: IRanking[];
  universityPrimaryColor: string;
};

function getStyles(brandColor: string, rowQuantity): { className: string; styles: JSX.Element } {
  return css.resolve`
    .rank {
      background-color: ${brandColor};
    }
    .ranking-grid {
      grid-template-rows: repeat(${rowQuantity}, 1fr);
    }
  `;
}

export default function TopRankedSubjects({ topRankedSubjects, universityPrimaryColor }: Props) {
  const { className, styles } = getStyles(
    universityPrimaryColor,
    Math.ceil(topRankedSubjects.length / 2),
  );

  return (
    <>
      {styles}
      <section className={`${moduleStyles[`top-ranked-program-section`]}`} id="top-ranked-programs">
        <h2>Top Ranked Subjects</h2>
        <div className={`${className} ${moduleStyles[`ranking-grid`]} ranking-grid`}>
          {topRankedSubjects.map((el) => (
            <div className={moduleStyles[`ranking-grid-item`]} key={`${el.id}`}>
              <div
                className={`${
                  moduleStyles[`rank-card`]
                } rounded-border-6 bg-white element-default-style card align-items-center flex-row`}
              >
                <span
                  className={`${
                    moduleStyles[`rank-stat`]
                  } ${className} rank fw-bold d-inline-flex align-items-center justify-content-center flex-shrink-0`}
                >
                  {el.rank}
                </span>
                <div className={`${moduleStyles[`rank-content`]}`}>
                  <h4 className="font-family-lato m-0">{el.subject}</h4>
                  <p className="external-link-disclaimer">
                    {el.source} {el.year}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
